'use strict';
import React from 'react';
import { Link } from 'react-router-dom';

class StaffCal extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
        durationTxt: ["Full", "Am", "Pm"]
    }

    getTime(day) {
        let startTime = '';
        let endTime = '';
        let type = '';
        let len = this.props.staffAtd && this.props.staffAtd.attendance ? this.props.staffAtd.attendance.length : 0;
        let result;
        let sTime, eTime;

        for (let i = 0; i < len; i++) {
            if (this.props.staffAtd.attendance[i].date == day) {
                let atd = this.props.staffAtd.attendance[i];
                //if onleave that day
                if (typeof this.props.staffAtd.attendance[i].type == 'number') {
                    if (atd.type != 7) {
                        type = (
                            atd.leaveTxt +
                            " (" + this.props.durationTxt[atd.duration] + ")"
                        );
                    } else {

                        type = (
                            atd.leaveTxt +
                            " (" + (atd.startTime ? (atd.startTime + " ~ " + atd.endTime) : "-") + ")"
                        );
                    }
                } else {
                    if (atd.startTime) {
                        if (atd.startTime) {
                            atd.startTime = new Date(atd.startTime);
                            let timeInMinute = (atd.startTime.getMinutes() < 10 ? "0" + atd.startTime.getMinutes() : atd.startTime.getMinutes());
                            sTime = atd.startTime.getHours() + ":" + timeInMinute;
                            startTime += startTime != "" ? "\n" + sTime : sTime;
                        } else {
                            startTime += startTime != "" ? "\n" + "--" : "--";
                        }
                        if (atd.endTime) {
                            atd.endTime = new Date(atd.endTime);
                            let timeOutMinute = (atd.endTime.getMinutes() < 10 ? "0" + atd.endTime.getMinutes() : atd.endTime.getMinutes());
                            eTime = atd.endTime.getHours() + ":" + timeOutMinute;
                            endTime += endTime != "" ? "\n" + eTime : eTime;
                        } else {
                            endTime += endTime != "" ? "\n" + "--" : "--";
                        }
                    }
                }
                result = { type: type, startTime: startTime, endTime: endTime };

            }
        }
        return result;
    }
    isToday(date) {
        let today = new Date();
        if (this.props.year == today.getFullYear() && this.props.month == today.getMonth() && date == today.getDate()) {
            return true;
        }
        return false;
    }
    getHoliday(year, month, date) {
        let content = [];
        let isHoliday = false;
        if (this.props.holiday) {
            if (this.props.holiday.holiday) {
                let s = this.props.holiday;

                s.holiday.map((holiday, index) => {
                    if (holiday.year == year && holiday.month == month && holiday.date == date) {
                        isHoliday = true;
                        content = content.concat(
                            <div className="a-i-lt" key={index}>{holiday.title}</div>
                        );
                    }
                });
                if (s.event) {
                    s.event.map((event, index) => {
                        if (event.year == year && event.month == month && event.date == date) {
                            content = content.concat(
                                <div className="lv-e" key={"e" + index}><b>{event.title}</b></div>
                            );
                        }
                    });
                }
            }
        }

        return { content: content, isHoliday: isHoliday };
    }
    renderRow(wk) {
        let day_row = [];
        for (let dy = 0; dy < 7; dy++) {
            if (wk == 0 && dy < this.props.start_day) {
                day_row = day_row.concat(<td className="cal-dis" key={"e" + (wk * 7 + dy)}></td>);
            } else if (wk * 7 + dy + 1 - this.props.start_day > this.props.last_date) {
                day_row = day_row.concat(<td className="cal-dis" key={"e" + (wk * 7 + dy)}></td>);
            } else {
                let date = wk * 7 + dy + 1 - this.props.start_day;
                let isToday = this.isToday(date);
                let attendance = this.getTime(date);
                let startTime, endTime;
                if (attendance) {
                    startTime = attendance.startTime ? attendance.startTime : "--";
                    endTime = attendance.endTime ? attendance.endTime : "--";
                }
                let displayTime = "";
                let displayLeave = "";
                let displayHoliday = "";


                if (attendance) {
                    if (attendance.startTime) {
                        displayTime = (
                            <div>
                                <div className="startTime"><b>Time In</b><br /><pre>{startTime}</pre></div>
                                <div className="endTime"><b>Time Out</b><br /><pre>{endTime}</pre></div>
                            </div>
                        );
                    }
                    if (attendance.type) {
                        displayLeave = (
                            <div>
                                <div className="a-i-lt">{attendance.type}</div>
                            </div>
                        );
                    }

                }

                displayHoliday = this.getHoliday(this.props.year, this.props.month, date);

                let className;
                if (isToday) {
                    className = "cal-tdy cal-dy ";
                } else {
                    className = "cal-dy ";
                }
                if (displayHoliday.isHoliday) {
                    className += "cal-hdy";
                }

                day_row = day_row.concat(
                    <td className={className} key={date}>

                        <div className="cal-date">{date}</div>
                        {displayHoliday.content}
                        {displayLeave}
                        {displayTime}
                    </td>
                );
            }
        }

        return (
            <tr key={"wk-" + wk}>
                {day_row}
            </tr>
        );
    }

    render() {

        let calender = [];
        for (let wk = 0; wk < this.props.last_wk; wk++) {
            calender = calender.concat(this.renderRow(wk));
        }

        return (
            <tbody>
                {calender}
            </tbody>
        )

    }
}
export default StaffCal;


// WEBPACK FOOTER //
// ./app/components/attdComponents/staffCal.js